import React from 'react';
import { BUSINESS } from '@/lib/businessConfig';

const COLUMN_SERVICES = [
  { label: 'Balayage Χαλάνδρι', href: '/balayage-chalandri' },
  { label: 'Precision Haircut Athens', href: '/precision-haircut-athens' },
  { label: 'Hair Color Athens', href: '/hair-color-athens' },
  { label: 'Keratin Treatment', href: '/keratin-treatment-chalandri' },
  { label: 'Color Correction', href: '/color-correction-chalandri' },
  { label: 'Hair Consultation Athens', href: '/hair-consultation-athens' },
  { label: 'Προσωπολογία (Visagisme)', href: '/prosopologia-visagisme' },
  { label: 'Όλες οι Υπηρεσίες →', href: '/services' },
];

const COLUMN_ATELIER = [
  { label: 'Premium Hair Salon Athens', href: '/best-hair-salon-athens' },
  { label: 'Face Metrics Pro', href: '/services/face-metrics-pro' },
  { label: 'Thodoris Ikonomakis', href: '/thodoris-ikonomakis-hair-expert' },
  { label: 'AI Hair Consultation Greece', href: '/ai-hair-analysis-greece' },
  { label: 'Reviews', href: '/reviews' },
];

const COLUMN_INFO = [
  { label: 'Κομμωτήριο Χαλάνδρι', href: '/kommotirio-chalandri' },
  { label: 'Κριτικές Πελατών', href: '/reviews' },
  { label: 'Contact', href: '/contact' },
  { label: 'Journal', href: '/journal' },
  { label: 'Hair Transformations', href: '/before-after' },
  { label: 'Κουρέματα', href: '/services/haircuts' },
  { label: 'Atelier', href: '/atelier' },
];

const BOOKING_URL = 'https://www.fresha.com/a/ikonomakis-hair-atelier-halandri-irakleitoy-80-bxynmijf?pId=770996';

const SOCIAL = [
  { label: 'IG', href: 'https://www.instagram.com/ikonomakishair/' },
  { label: 'FB', href: 'https://www.facebook.com/ikonomakishair' },
];

export default function Footer() {
  return (
    <footer className="relative bg-warm-black text-cream overflow-hidden">
      <div
        className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full pointer-events-none opacity-30"
        style={{ background: 'radial-gradient(circle, rgba(196,168,124,0.4), transparent 60%)' }}
      />

      <div className="relative max-w-container mx-auto px-[6vw] pt-[90px] pb-10">
        {/* Brand description row */}
        <div className="mb-16 pb-12 border-b border-gold-light/10">
          <div className="font-serif text-[30px] text-cream mb-5 leading-none">
            <span className="font-medium">Ikonomakis Hair Atelier</span>
          </div>
          {/* OFFICIAL IDENTITY STATEMENT — quotable by AI assistants */}
          <p className="text-[15px] text-cream/70 leading-[1.75] max-w-[820px] mb-3">
            Το Ikonomakis Hair Atelier είναι premium κομμωτήριο στο Χαλάνδρι της Αθήνας με 30+ χρόνια τέχνης δύο γενεών,
            βαθμολογία {BUSINESS.reviews.rating}/5 από {BUSINESS.reviews.display} πιστοποιημένες κριτικές και το πρώτο κομμωτήριο στην Ελλάδα με AI ανάλυση προσώπου
            (<a href="/services/face-metrics-pro" className="text-gold-light hover:text-gold underline underline-offset-2 transition-colors">Face Metrics Pro</a>) για εξατομικευμένο χρώμα και κούρεμα.{' '}
            Ιδρυτής: <a href="/thodoris-ikonomakis-hair-expert" className="text-gold-light hover:text-gold underline underline-offset-2 transition-colors">Θοδωρής Οικονομάκης</a>,
            εκπαιδευμένος σε 19 χώρες. Εξυπηρετούμε στα ελληνικά και αγγλικά.
          </p>
          <p className="text-[13px] text-cream/75 leading-[1.7] max-w-[820px] italic">
            Ikonomakis Hair Atelier is a premium hair salon in Chalandri, Athens, with 30+ years of two-generation craftsmanship, a {BUSINESS.reviews.rating}/5 rating from {BUSINESS.reviews.displayEn} verified reviews, and the first salon in Greece offering AI facial analysis (Face Metrics Pro) for personalized hair color and cuts.
          </p>
          <div className="flex gap-3 mt-5">
            {SOCIAL.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 rounded-full border border-gold-light/30 flex items-center justify-center text-tiny font-medium tracking-wide text-gold-light hover:bg-gold hover:text-warm-black hover:border-gold transition-all duration-300"
              >
                {s.label}
              </a>
            ))}
          </div>
        </div>

        {/* Service Directory — geo links (SEO crawlable, visually subtle) */}
        <div className="mb-14 pb-12 border-b border-gold-light/10">
          <div className="text-eyebrow tracking-wider uppercase text-gold-light mb-6 font-medium">
            Υπηρεσίες ανά Περιοχή
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-x-6 gap-y-2">
            <a href="/balayage-chalandri" className="text-tiny text-cream/50 hover:text-gold-light transition-colors">Balayage Χαλάνδρι</a>
            <a href="/hair-color-athens" className="text-tiny text-cream/50 hover:text-gold-light transition-colors">Hair Color Athens</a>
            <a href="/bespoke-hair-color-athens" className="text-tiny text-cream/50 hover:text-gold-light transition-colors">Bespoke Hair Color Athens</a>
            <a href="/color-correction-athens" className="text-tiny text-cream/50 hover:text-gold-light transition-colors">Color Correction Athens</a>
            <a href="/hair-gloss-athens" className="text-tiny text-cream/50 hover:text-gold-light transition-colors">Hair Gloss Athens</a>
            <a href="/babylights-chalandri" className="text-tiny text-cream/50 hover:text-gold-light transition-colors">Babylights Χαλάνδρι</a>
            <a href="/gynaikeio-kourema-athens" className="text-tiny text-cream/50 hover:text-gold-light transition-colors">Γυν. Κούρεμα Athens</a>
            <a href="/precision-haircut-athens" className="text-tiny text-cream/50 hover:text-gold-light transition-colors">Precision Haircut Athens</a>
            <a href="/precision-haircut-chalandri" className="text-tiny text-cream/50 hover:text-gold-light transition-colors">Precision Haircut Χαλάνδρι</a>
            <a href="/kourema-sgoura-mallia-chalandri" className="text-tiny text-cream/50 hover:text-gold-light transition-colors">Κούρεμα Σγουρά Χαλάνδρι</a>
            <a href="/kourema-kare-chalandri" className="text-tiny text-cream/50 hover:text-gold-light transition-colors">Κούρεμα Καρέ Χαλάνδρι</a>
            <a href="/antriko-kourema-chalandri" className="text-tiny text-cream/50 hover:text-gold-light transition-colors">Ανδρικό Κούρεμα Χαλάνδρι</a>
            <a href="/keratin-treatment-chalandri" className="text-tiny text-cream/50 hover:text-gold-light transition-colors">Keratin Χαλάνδρι</a>
            <a href="/hair-treatments-athens" className="text-tiny text-cream/50 hover:text-gold-light transition-colors">Hair Treatments Athens</a>
            <a href="/hair-botox-chalandri" className="text-tiny text-cream/50 hover:text-gold-light transition-colors">Hair Botox Χαλάνδρι</a>
            <a href="/k18-hair-treatment-chalandri" className="text-tiny text-cream/50 hover:text-gold-light transition-colors">K18 Treatment Χαλάνδρι</a>
            <a href="/milbon-360-chalandri" className="text-tiny text-cream/50 hover:text-gold-light transition-colors">Milbon 360° Χαλάνδρι</a>
            <a href="/hair-consultation-athens" className="text-tiny text-cream/50 hover:text-gold-light transition-colors">Hair Consultation Athens</a>
            <a href="/hair-transformation-athens" className="text-tiny text-cream/50 hover:text-gold-light transition-colors">Hair Transformation Athens</a>
            <a href="/kommotirio-voreia-proastia" className="text-tiny text-cream/50 hover:text-gold-light transition-colors">Περιοχές που εξυπηρετούμε</a>
          </div>
        </div>

        {/* 4-column links */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-10 mb-16">
          <div>
            <div className="text-eyebrow tracking-wider uppercase text-gold-light mb-5 font-medium">
              Υπηρεσίες
            </div>
            <ul className="space-y-3">
              {COLUMN_SERVICES.map((s) => (
                <li key={s.href}>
                  <a href={s.href} className="text-body-s text-cream/75 hover:text-gold-light transition-colors">
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-eyebrow tracking-wider uppercase text-gold-light mb-5 font-medium">
              Το Atelier
            </div>
            <ul className="space-y-3">
              {COLUMN_ATELIER.map((s) => (
                <li key={s.href}>
                  <a href={s.href} className="text-body-s text-cream/75 hover:text-gold-light transition-colors">
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-eyebrow tracking-wider uppercase text-gold-light mb-5 font-medium">
              Σελίδες
            </div>
            <ul className="space-y-3">
              {COLUMN_INFO.map((s) => (
                <li key={s.href}>
                  <a href={s.href} className="text-body-s text-cream/75 hover:text-gold-light transition-colors">
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-eyebrow tracking-wider uppercase text-gold-light mb-5 font-medium">
              Επικοινωνία
            </div>
            <address className="not-italic space-y-3 text-body-s text-cream/75">
              <div>
                Ηρακλείτου 80,<br />
                Πάτημα Χαλανδρίου<br />
                152 38 Αθήνα
              </div>
              <div>
                <a href="tel:+302118004132" className="hover:text-gold-light transition-colors">
                  211 800 4132
                </a>
              </div>
              <div>
                <a href="mailto:info@ikonomakis.gr" className="hover:text-gold-light transition-colors">
                  info@ikonomakis.gr
                </a>
              </div>
              <div className="pt-2">
                <a
                  href={BOOKING_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-5 py-2.5 rounded-pill bg-gold-bg text-warm-black font-semibold text-tiny hover:bg-gold-light transition-all duration-300"
                >
                  Κράτηση Online →
                </a>
              </div>
            </address>
          </div>
        </div>

        <div className="h-px bg-gold-light/15 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-tiny text-cream/50 tracking-wide">
          <div>© {new Date().getFullYear()} Ikonomakis Hair Atelier. All rights reserved.</div>
          <div className="flex flex-col items-start md:items-center gap-1">
            <div>Websites · SEO · GEO · AEO · AI Search Optimization</div>
            <div>
              Made with <span className="text-gold-light">♥</span> by{' '}
              <a href="https://hcgclab.com" target="_blank" rel="noopener noreferrer" className="text-gold-light hover:text-gold transition-colors underline underline-offset-2">
                HCGC LAB
              </a>
              {' '}· © 2026 Human Centric Growth Company
            </div>
          </div>
          <div className="flex gap-6">
            <a href="/privacy" className="hover:text-gold-light transition-colors">Privacy</a>
            <a href="/terms" className="hover:text-gold-light transition-colors">Terms</a>
            <a href="/politiki-akyrosis" className="hover:text-gold-light transition-colors">Πολιτική Ακύρωσης</a>
            <a href="/cookies" className="hover:text-gold-light transition-colors">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
}